import { useEffect, useState } from "react";

import useFetch from "../../../hooks/useFetch";

import { ReactComponent as IconRDV } from "../../../img/icons/rdv_call.svg";
import { ReactComponent as IconCalendar } from "../../../img/icons/calendar.svg";
import { ReactComponent as IconArrow } from "../../../img/icons/arrow-right.svg";
import Button from "../../../components/Button";

const CtaReceiveQuotation = ({ contactId, opportunityId, simId, isResultRecord }) => {
  const [callBackUrl, setCallBackUrl] = useState(null);

  const [doGetQuotation, responseGetQuotation, isLoading, getQuotationError] = useFetch(
    `${process.env.REACT_APP_API_URL}?action=artyseo_quotation`
  );

  const getQuotation = (url) => {
    setCallBackUrl(url);
    const getQuotationOptions = {
      method: 'POST',
      body: JSON.stringify({
        cid: contactId,
        oid: opportunityId,
        sid: simId
      }),
    };
    doGetQuotation(getQuotationOptions);
  };

  useEffect(() => {
    if (responseGetQuotation && callBackUrl)
      window.location.href = callBackUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [responseGetQuotation, callBackUrl]);

  useEffect(() => {
    if (getQuotationError && callBackUrl)
      window.location.href = callBackUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getQuotationError, callBackUrl]);

  return (
    <div className="buttons">
      { isResultRecord ?
      <div className="rdv" onClick={() => { if (!isLoading) getQuotation('/simulateur-rdv'); }}><IconCalendar class="cal" />Prenez RDV <IconRDV class="rdv" /></div>
      :
      <Button 
        variant='get-quotation' 
        IconAfter={IconArrow} 
        onclick={() => { if (!isLoading) getQuotation('/simulateur-demande-devis'); }}
      >
        Récupérer mon étude par mail
      </Button>
      }
    </div>
  )
};

export default CtaReceiveQuotation;